import Tables from 'src/class/Tables';
import i18n from 'src/i18n';


const configTable = () => {
  const Table = { ...Tables.Table };
  Table.tableColumns = [
    {
      prop: 'date',
      label: i18n.t('common_words.date'),
      minWidth: 200,
      sortable: true,
      align: 'center',
    },
    {
      prop: 'ground_nutrient.description',
      label: i18n.t('samples.element'),
      minWidth: 150,
      sortable: true,
      align: 'center',
    },
    {
      prop: 'crop.name',
      label: i18n.t('common_words.crop'),
      minWidth: 150,
      sortable: true,
    },
    {
      prop: 'zone.name',
      label: i18n.t('common_words.zones'),
      minWidth: 170,
      sortable: true,
    },
    {
      prop: 'subzone.name',
      label: i18n.t('common_words.sub_zones'),
      minWidth: 150,
      sortable: true,
    },
    {
      prop: 'crop_variety_names',
      label: i18n.t('common_words.variety'),
      minWidth: 150,
      sortable: true,
    }

  ];

  return { Table };
};

export default configTable;

